'use client';

import { useEffect, useRef } from 'react';

export default function useInterval(
	callback: () => void,
	delayMs: number | null,
	runOnCallbackChange = false
) {
	const savedCallback = useRef<() => void>(null);

	// Remember the latest callback.
	useEffect(() => {
		savedCallback.current = callback;
		runOnCallbackChange && savedCallback.current();
	}, [callback, runOnCallbackChange]);

	// Set up the interval.
	useEffect(() => {
		function tick() {
			savedCallback.current && savedCallback.current();
		}

		if (delayMs !== null) {
			tick();

			const id = setInterval(tick, delayMs);
			return () => {
				clearInterval(id);
			};
		}
	}, [delayMs]);
}
